import {
  type EuMaxTaxExposureDto,
  EuMaxTaxExposureDtoTreatmentEnum,
} from '@b-stock/listing-api-client'

import getMaxVatCents from './getMaxVatCents'

// What the TLC breakdown's "Estimated VAT" row renders (FP-3262). One
// flat shape instead of the DTO so the row never has to know the
// treatment enum; the amount is already clamped by `getMaxVatCents`.
export type TlcVatInfo = {
  /** Rate as a fraction (0.19). 0 when unavailable or reverse charge. */
  rate: number
  amountCents: number
  /** FR-020 — a real answer, rendered as such; never €0.00. */
  estimateUnavailable: boolean
  /** FR-021 — the reverse-charge legend, when that treatment applies. */
  legend?: string
}

// FP-3264 — the row VAT-bearing listings show until svc can estimate
// (no address or bid yet, request failed), so VAT is never silently
// dropped from the breakdown or its tooltip.
export const unavailableTlcVatInfo: Readonly<TlcVatInfo> = {
  rate: 0,
  amountCents: 0,
  estimateUnavailable: true,
}

const getTlcVatInfo = (
  data: EuMaxTaxExposureDto | undefined
): TlcVatInfo | undefined => {
  if (!data) {
    return undefined
  }
  if (data.estimateUnavailable) {
    return unavailableTlcVatInfo
  }
  const isReverseCharge =
    data.treatment === EuMaxTaxExposureDtoTreatmentEnum.ReverseCharge
  return {
    rate: isReverseCharge ? 0 : Number.parseFloat(data.rate ?? '0') || 0,
    amountCents: getMaxVatCents(data),
    estimateUnavailable: false,
    ...(isReverseCharge &&
      data.treatmentLegend && {
        legend: data.treatmentLegend,
      }),
  }
}

export default getTlcVatInfo
